export default __webpack_public_path__ + "static/media/032-rugby.889cd634.svg";